/**
 * 宝箱弹窗调试页：直接预览金币 / 金币+食物 两种展示
 * 访问 /test-treasure 即可调试，无需登录、不请求接口
 */
import React, { useState, useCallback } from 'react';
import { Button } from 'antd';
import WkModal from 'components/Modal';
import TreasureBoxModal from 'components/TreasureBoxModal';
import Fireworks from 'components/Fireworks';
import { TREASURE_FOOD_LIST } from 'constants/treasureFoods';
import './index.scss';

const SAMPLE_COIN = 88;

const TestTreasure = () => {
  const [visible, setVisible] = useState(false);
  const [coin] = useState(SAMPLE_COIN);
  const [food, setFood] = useState(null);

  const openCoinOnly = useCallback(() => {
    setFood(null);
    setVisible(true);
  }, []);

  const openCoinAndFood = useCallback(() => {
    const item = TREASURE_FOOD_LIST[Math.floor(Math.random() * TREASURE_FOOD_LIST.length)];
    setFood(item);
    setVisible(true);
  }, []);

  const content = (
    <TreasureBoxModal coin={coin} food={food} />
  );

  return (
    <div className="test-treasure-page">
      <h1 className="test-treasure-title">宝箱弹窗调试</h1>
      <p className="test-treasure-desc">仅用于 UI 预览，不请求接口</p>
      <div className="test-treasure-btns">
        <Button type="primary" size="large" onClick={openCoinOnly}>
          开宝箱（仅金币）
        </Button>
        <Button type="primary" size="large" onClick={openCoinAndFood}>
          开宝箱（金币+食物）
        </Button>
      </div>

      <Fireworks visible={visible} duration={3000} />
      <WkModal
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        content={content}
        okText="确定"
        tongquStyle
      />
    </div>
  );
};

export default TestTreasure;
